import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "src/environments/environment";

/** Petición de solicitud de cumplimentación de datos (Contrato/Centro). */
export interface SolicitudCumplimentacionRequest {
	/** Tipo de entidad en español, como espera el backend ("Contrato" | "Centro"). */
	entidad: string;
	entidadId: number;
	destinatarioEmpleadoId: number;
	destinatarioEmail: string;
	destinatarioNombre: string;
	mensaje: string;
}

/** Respuesta del alta: si el correo no salió, la solicitud queda registrada igualmente. */
export interface SolicitudCumplimentacionResponse {
	id: number;
	emailEnviado: boolean;
	/** Email efectivo de entrega cuando el backend redirige (p. ej. entornos no productivos). */
	redirigidoA?: string;
}

/**
 * Solicitudes de cumplimentación de datos: un usuario con la policy
 * `App.Solicitud.Cumplimentacion` pide a una persona de la entidad (Contrato/Centro)
 * que complete su ficha. El backend registra la solicitud y envía el correo
 * (con copia al solicitante y enlace directo a la ficha).
 */
@Injectable({ providedIn: "root" })
export class SolicitudCumplimentacionService {
	private readonly apiUrl = `${environment.api.root}/SolicitudCumplimentacion`;

	constructor(private readonly http: HttpClient) {}

	/** Registra la solicitud y dispara el envío del correo. */
	crear(
		body: SolicitudCumplimentacionRequest,
	): Observable<SolicitudCumplimentacionResponse> {
		return this.http.post<SolicitudCumplimentacionResponse>(this.apiUrl, body);
	}
}
